const Footer = () => {
    const template = `
        <div class="copyright-text" x-data >© Copyright <span x-text="new Date().getFullYear();"></span> JoelStamey.com. All rights reserved.</div>
  `;

    return template;
};

export default Footer;